module.exports = __webpack_public_path__ + "img/tick.97cda7ee.svg";